import type { SelectItem } from '@/_components';

export const PAGINATION_OPTIONS: Array<SelectItem> = [
  { name: '10', value: '10' },
  { name: '20', value: '20' },
  { name: '50', value: '50' },
];
